export default "__VITE_ASSET__CfPn$_UK__"